import { actions } from './actions';

const initialState = {
  alertMessage: null,
  dashboardResponses:[]
}

const reducer = (state = initialState, changeAction) => {
  switch (changeAction.type) {
    case actions.FETCH_REQUEST: {
      const obj = Object.assign({}, state);
      obj[changeAction.key] = {
        isFetching: true,
        error: false,
      };
      return obj;
    }
    case actions.FETCH_REQUEST_SUCCESS: {
      const obj = Object.assign({}, state);
      obj[changeAction.key] = {
        isFetching: false,
        error: false,
        data: changeAction.data,
      };
      return obj;
    }
    case actions.FETCH_REQUEST_ERROR: {
      const obj = Object.assign({}, state);
      obj[changeAction.key] = {
        isFetching: false,
        error: true,
        errorMessage: changeAction.error,
      };
      return obj;
    }

    case actions.SET_DATA: {
      const obj = Object.assign({}, state);
      obj[changeAction.key] = changeAction.value;
      return obj;
    }

    case 'UPDATE_DASHBOARD':
      if(!state.dashboardResponses.some(item => item.dashboardId == changeAction.data.dashboardId)){
        return Object.assign({},state,{
          dashboardResponses: state.dashboardResponses.concat([changeAction.data])
        });
      }
      return state;

    

      case 'REMOVE_DASHBOARD': 
      
          return Object.assign({},state,{
            dashboardResponses: state.dashboardResponses.filter(item => !changeAction.data.some(rl => rl.dashboardId == item.dashboardId) )
          }); 
        

    case 'CLEAR_DASHBOARD':
      return Object.assign({},state,{
        dashboardResponses:[]
      });

    default:
      return state;
  }
};
export default reducer;
